export const linkToBorrowerApp = (path: string) => (
  `https://app.${document.location.hostname}${path}`
)